import { Routes } from '@angular/router';
import { authGuard, domainAdminGuard } from '@privaci/core';

/**
 * Admin routing (FEAT-F1, A34). Two public routes — the staff sign-in and the access-denied landing —
 * plus the shell, which is gated by `authGuard` (must be signed in) then `domainAdminGuard` (must be
 * a DomainAdmin). Every destination under the shell inherits both guards and renders a real screen
 * (dashboard/users/sites/classifications/tracker-review/subscriptions/ai-costs/skills/knowledge/
 * queue-health/scanner/operations/admin-audit/scan-performance/observability).
 */
export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./pages/sign-in/sign-in.component'),
  },
  {
    // domainAdminGuard's redirect target for an authenticated non-admin (ADMIN_RESTRICTED_ROUTE).
    // Standalone (outside the shell) so a non-admin never sees admin chrome.
    path: 'access-denied',
    loadComponent: () => import('./pages/access-denied/access-denied.component'),
  },
  {
    path: '',
    canActivate: [authGuard, domainAdminGuard],
    loadComponent: () => import('./core/layout/admin-shell.component'),
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadComponent: () => import('./pages/dashboard/dashboard.component'),
      },
      {
        path: 'users',
        loadComponent: () => import('./pages/users/users.component'),
      },
      {
        path: 'sites',
        loadComponent: () => import('./pages/sites/sites.component'),
      },
      {
        path: 'classifications',
        loadComponent: () => import('./pages/classifications/classifications.component'),
      },
      {
        path: 'tracker-review',
        loadComponent: () => import('./pages/tracker-review/tracker-review.component'),
      },
      {
        path: 'subscriptions',
        loadComponent: () => import('./pages/subscriptions/subscriptions.component'),
      },
      {
        path: 'ai-costs',
        loadComponent: () => import('./pages/ai-costs/ai-costs.component'),
      },
      {
        path: 'skills',
        loadComponent: () => import('./pages/skills/skills.component'),
      },
      {
        path: 'knowledge/sources',
        loadComponent: () => import('./pages/knowledge/sources.component'),
      },
      {
        path: 'knowledge/playground',
        loadComponent: () => import('./pages/knowledge/playground.component'),
      },
      {
        path: 'queue-health',
        loadComponent: () => import('./pages/queue-health/queue-health.component'),
      },
      {
        path: 'scanner',
        loadComponent: () => import('./pages/scanner/scanner.component'),
      },
      {
        path: 'operations',
        loadComponent: () => import('./pages/operations/operations.component'),
      },
      {
        path: 'admin-audit',
        loadComponent: () => import('./pages/admin-audit/admin-audit.component'),
      },
      {
        path: 'scan-performance',
        loadComponent: () => import('./pages/scan-performance/scan-performance.component'),
      },
      {
        path: 'observability',
        loadComponent: () => import('./pages/observability/observability.component'),
      },
      {
        path: '**',
        loadComponent: () => import('./pages/not-found/not-found.component'),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
